import axios from 'axios';

export default {
  getToken() {
    return localStorage.getItem('user-token');
  },
  async getCongenersFiltered(params = {}) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/congeners`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params,
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async createCongener(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/congeners`,
        {
          name: payload.name,
          susepCode: payload.susepCode,
          isActive: payload.isActive,
          id_i4pro: Number(payload.idI4pro),
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCongener(id, payload) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/congeners/${id}`,
        {
          name: payload.name,
          susepCode: payload.susepCode,
          isActive: payload.isActive,
          id_i4pro: Number(payload.idI4pro),
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async reactivateCongeners(ids) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/congeners/status`,
        {
          ids: ids,
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deactivateCongeners(ids) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/congeners/status`,
        {
          ids: ids,
          deactivate: true,
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
